//
//
//
//
//

import FeeLoader from "./fee-loader";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "FeesLoader",
  components: {
    FeeLoader
  }
});